// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__Bdk96","title":"Images90_title__1hoDv","images":"Images90_images__bZeCQ"};